import * as React from 'react';
import styled from 'styled-components';
import Tab, { IITabProps } from '../tab/Tab';
// ############################ Styles ###########################
// tslint:disable:variable-name

const STabGroup = styled.div``;

// tslint:enable:variable-name
// ############################ End Styles ###########################

// tslint:disable-next-line:no-empty-interface
export interface ITabsGroupsProps {
  children: Array<IITabProps>;
}

// tslint:disable-next-line:variable-name
const TabGroup: React.FC<ITabsGroupsProps> = ({ children }) => {
  return (
    <STabGroup>
      {children.map((tab: IITabProps, index) => (
        <Tab key={index} {...tab} />
      ))}
    </STabGroup>
  );
};

export default TabGroup;
